import { ReactNode } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { useBrandingContext } from "../contexts/BrandingContext";

/**
 * Reads the branded theme out of BrandingContext and applies it via MUI's ThemeProvider.
 * Must be rendered inside a <BrandingProvider>.
 */
export const BrandedThemeProvider = ({ children }: { children: ReactNode }) => {
  const { theme } = useBrandingContext();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
